// extracted by mini-css-extract-plugin
export default {"registerContainer":"AdminPage_registerContainer__+0Jwi"};